var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLava(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 33,
    viewBox: "0 0 115 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.0753C0 25.4318 0.0579044 25.7878 0.200017 26.1148C1.22253 28.4675 3.16255 30.1857 5.52034 31.2786C9.81622 29.8347 11.3714 26.312 11.5491 24.7169V17.1842C11.5491 14.0095 10.9656 10.5886 8.32353 8.82834C5.54417 6.97659 2.05784 6.40332 0 6.40332V25.0753Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2851 0C18.0783 0.29002 13.0644 3.2898 12.2229 7.5593C12.1972 7.68996 12.1872 7.82346 12.1872 7.95664V13.9798V24.9833C12.008 26.5926 10.5921 30.1762 6.3623 31.6363C12.9057 34.1669 22.0159 32.2387 24.1561 26.0237C24.2485 25.7555 24.2851 25.4707 24.2851 25.187V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7109 26.4151V5.0459H41.3467V23.6278H52.3541V26.4151H37.7109Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9355 26.4151L63.1411 5.0459H67.2105L75.3493 26.4151H71.6134L69.4787 20.9069H60.8395L58.7048 26.4151H54.9355ZM61.4066 18.1196H68.8783L65.1424 8.33091L61.4066 18.1196Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9865 26.4151L74.7809 5.0459H78.5501L84.9878 22.5328L91.4255 5.0459H95.1947L87.0559 26.4151H82.9865Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9748 26.4151L102.18 5.0459H106.25L114.389 26.4151H110.653L108.518 20.9069H99.8788L97.744 26.4151H93.9748ZM100.446 18.1196H107.918L104.182 8.33091L100.446 18.1196Z",
    fill: "white"
  })));
}

export default __webpack_public_path__ + "media/c1c0ad30.svg";
export { SvgLava as ReactComponent };